//Termos de Uso e Política de Privacidade.
export type LegalDocumentType = 'terms' | 'privacy';

//Rota pública de cada documento. O texto fica em public/legal/<idioma>/.
export const LEGAL_DOCUMENT_PATHS: Record<LegalDocumentType, string> = {
    terms: '/termos-de-uso',
    privacy: '/politica-de-privacidade',
};

export interface LegalCurrentVersion {
    version: string;
    //Data em que a versão entrou em vigor (AAAA-MM-DD).
    effectiveDate?: string;
}

export interface LegalAcceptanceStatus {
    currentVersion: string;
    acceptedVersion: string | null;
    acceptedAt: string | null;
    //Falta aceitar a versão vigente: nunca aceitou ou aceitou uma anterior.
    pending: boolean;
}

//Seção do documento, para o índice da página.
export interface LegalSection {
    number: string;
    title: string;
}
